import React from 'react';

const Icon = (props: IconProps): JSX.Element => {
    const { id, children, className } = props;
    return (
        <div id={id} className={className}>
            {children}
        </div>
    );
};

type IconProps = {
    id: string | undefined;
    children: React.ReactNode;
    className: string | undefined;
};

export default Icon;
